import { PageHead } from '@components/PageHead'
import { Icon, type IconName } from '@/icons/Icon'
import { useTranslation } from '@/i18n'

/**
 * `#tools` 用ランディングページ。
 *
 * 各サブツール (パスワード生成 / インポート / エクスポート) を
 * カード形式で並べる。ヘッダの ToolsSubNav は引き続き chip ナビとして表示。
 */

interface ToolCard {
  route: 'tools/generator' | 'tools/import' | 'tools/export'
  icon: IconName
  titleKey: string
  descKey: string
}

const CARDS: readonly ToolCard[] = [
  {
    route: 'tools/generator',
    icon: 'key',
    titleKey: 'tools.landing.generator_title',
    descKey: 'tools.landing.generator_desc',
  },
  {
    route: 'tools/import',
    icon: 'upload',
    titleKey: 'tools.landing.import_title',
    descKey: 'tools.landing.import_desc',
  },
  {
    route: 'tools/export',
    icon: 'download',
    titleKey: 'tools.landing.export_title',
    descKey: 'tools.landing.export_desc',
  },
]

export const ToolsLandingPage = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div>
      <PageHead title={t('tools.landing.title')} sub={t('tools.landing.sub')} />
      <div className="page-body">
        <div className="tools-landing-grid">
          {CARDS.map(card => (
            <button
              key={card.route}
              type="button"
              className="card tools-landing-card"
              onClick={() => {
                window.location.hash = card.route
              }}
              data-testid={`tools-landing-${card.route.split('/')[1]}`}
            >
              <span className="tools-landing-card-icon" aria-hidden="true">
                <Icon name={card.icon} />
              </span>
              <span className="tools-landing-card-body">
                <span className="tools-landing-card-title">{t(card.titleKey)}</span>
                <span className="tools-landing-card-desc">{t(card.descKey)}</span>
              </span>
              <span className="tools-landing-card-chevron" aria-hidden="true">
                <Icon name="chevron-right" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
